import React from "react";
import { makeStyles, createStyles, Theme } from "@material-ui/core";
import { SidebarMemberList } from "./SidebarMemberList";
import { SidebarAdminList } from "./SidebarAdminList";
import { SidebarUserList } from "./SidebarUserList";
import { getSelfUser } from "../../helpers";

/** スタイル定義 */
const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    container: {
      height: "100%",
      display: "flex",
      flexDirection: "column",
      justifyContent: "space-between",
      background: theme.extra.sidebar.background,
    },
  })
);

/** サイドバー */
export function Sidebar() {
  const classes = useStyles();

  const user = getSelfUser();

  //--------------------
  // コンポーネント
  return (
    <div className={classes.container}>
      <div>
        {user && user.is_admin ? <SidebarAdminList /> : <SidebarMemberList />}
      </div>
      <div style={{ marginBottom: "1rem" }}>
        <SidebarUserList />
      </div>
    </div>
  );
}
